import { APIModel } from "./api-model";

export class MatchEffectiveValue extends APIModel {
  effective_seq: number;
  effective_rank: number;

  static fieldsToMap = {
    directNA: [
      'effective_seq',
      'effective_rank'
    ]
  }

  static buildFromAPI(record: any): MatchEffectiveValue {
    const row = new MatchEffectiveValue();
    record = record || {};

    this.mapFieldsNA<MatchEffectiveValue>(MatchEffectiveValue.fieldsToMap.directNA, record, row);

    return row;
  }
}